import { jsonAxios } from "components/axios";

interface IFileNateon {
    id: number
    carrierName: string
    originCode: string
    originAddress: string
    destinationCode: string
    destinationAddress: string
}

// quoteDetail, quoteSimple, special, quoteConfirm, quoteFile, companyFile
const sendTeamRoom = async (type: string, msg: string, id?: string) => {
    const reqData = {
        messageType: type,
        content: msg,
        id: id
    }
    return await jsonAxios.post('send/nateon', reqData)
}

export {
    sendTeamRoom
}

export type {
    IFileNateon
}